import React, { useEffect, useState } from "react";
import { cn } from "@/lib/utils";

/**
 * Cuenta Vaca brand logo.
 *
 * Variants:
 *   - "mark"  : icon only (cow head + clipboard + RFID tag)
 *   - "name"  : icon + "Cuenta Vaca" wordmark (no tagline)
 *   - "full"  : icon + "Cuenta Vaca" + "INVENTARIO | IDENTIFICA | CONTROLA"
 *
 * Observes the `.dark` class on <html> with a MutationObserver so the dark
 * asset (logo-*-dark.png) loads instantly regardless of theme hook ordering.
 * Caller can force a variant with forceLight / forceDark.
 */
function readIsDark() {
  if (typeof document === "undefined") return false;
  return document.documentElement.classList.contains("dark");
}

export function Logo({
  variant = "mark",
  className = "",
  alt = "Cuenta Vaca",
  forceLight = false,
  forceDark = false,
}) {
  const [isDark, setIsDark] = useState(readIsDark);

  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    const html = document.documentElement;
    setIsDark(html.classList.contains("dark"));
    const observer = new MutationObserver(() => {
      setIsDark(html.classList.contains("dark"));
    });
    observer.observe(html, { attributes: true, attributeFilter: ["class"] });
    return () => observer.disconnect();
  }, []);

  const dark = forceDark || (!forceLight && isDark);
  const src = `/brand/logo-${variant}${dark ? "-dark" : ""}.png`;

  return (
    <img
      src={src}
      alt={alt}
      data-testid={`brand-logo-${variant}`}
      data-theme={dark ? "dark" : "light"}
      draggable={false}
      className={cn("select-none object-contain", className)}
    />
  );
}
